import { DayOfWeek as y, IntervalType as r } from "@ancon/wildcat-types";
import x from "moment";
import { DaysOfWeekMap as E } from "../shared/constants.mjs";
import f from "../date/createLocalTimezoneMoment.mjs";
import k from "./getExpressServiceIntervalStart.mjs";
import S from "./getExpressServiceIntervalEnd.mjs";
import "../time/getTimeSpanParts.mjs";
function O(n, i) {
  const t = x();
  let o = t.clone().add(1, "day").startOf("day");
  function a(e) {
    const m = e.type === r.Exception, p = m ? f(e.periodFrom) : t, d = m ? f(e.periodTo) : t, s = k(
      p,
      e,
      i
    ), c = S(
      d,
      e,
      i
    );
    s.isBetween(t, o) ? o = s : c.isBetween(t, o) && (o = c);
  }
  return n.forEach((e) => {
    switch (e.type) {
      case r.Exception:
        a(e);
        break;
      case r.Normal:
      default:
        // Every day in the week
        (e.dayOfWeek === y.Everyday || // Specific day in the week
        e.dayOfWeek === E[t.isoWeekday()]) && a(e);
        break;
    }
  }), o;
}
export {
  O as default
};
